import React from "react";
import "../Card/Card.scss";


const Card = ({ icon, text, groups, bgcolor }) => {

  return (
    <div className='dashboard_card_container' style={{ backgroundColor: `${bgcolor}` }} >
      <div className='dashboard_card_icon_container'>{icon}</div>
      <div className='dashboard_card_text'>
        <div className='dashboard_card_left_text'>
          <p className='dashboard_card_description'>{text}</p>
          <p className='dashboard_card_number_of_groups'>{groups}</p>
        </div>
      </div>
    </div>
  );
};

export default Card;
